<script lang="ts">
  import { Activity, type Exercise } from '@/Common/ActivityFunctions';
  import TodayActivityCard from './TodayActivityCard.svelte';
  import type { TodaysActivities } from '@/Common/constants';

  export let activity: Exercise;
  export let todaysActivities: TodaysActivities;
  export let activityImageCarouselNumber: Record<string, number>;
  export let conflictNotes: string[] = [];

  function markerColor(a) {
    if (Activity.isHidden(a) || Activity.isDuplicate(a)) return 'bg-zinc-400';
    if (Activity.isForecast(a)) return Activity.isRest(a) ? 'bg-zinc-400' : 'bg-[#64dfdf]';
    if (Activity.isPlanned(a)) return 'bg-[rgb(198,170,255)]';
    return 'bg-emerald-500';
  }

</script>

<div class="relative ml-4 md:ml-8">
  <div class={`absolute -left-2 top-4 h-3 w-3 rounded-full ring-2 ring-white ${markerColor(activity)}`}></div>
  <TodayActivityCard {todaysActivities} {activity} useTimelineLayout={true} bind:activityImageCarouselNumber conflictNotes={conflictNotes} />
</div>
